import styled from "styled-components";

export const Root = styled.div`
  width: 100%;
  position: relative;
  /* BV parity: BV's page-break plugin container renders the page number with no
     bottom margin. This 20px made the element wrapper 75px vs BV's 55px, pushing
     every row after the page break 20px lower - visible on chapter openers, where
     the theme's absolutely positioned .chapterNumber/.chapterTitle h1s (top: -Xem)
     anchor to the following text row and landed 20px lower over the fixed-height
     hero image (BVEW-2168). */
  /* margin-bottom: 20px; */
`;

export const PageNumber = styled.div`
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
`;
